<template>
    <p class="d-flex align-items-center green-color fs-12 fw-600 my-2">
        <span style="width: 30px">
            <img alt="check_label" :src="`/images/${icon}.svg`" />
        </span>
        <router-link class="system_link-style" exact target="_blank" :to="to"><slot></slot></router-link>
    </p>
</template>

<script>
export default {
    name: 'cabinet-fl44-card-info-link',
    props: ['to', 'icon']
};
</script>
